<template>
  <div>
    <my-container>
      <main-title center wave>Лица школы</main-title>
      <v-row justify="center">
        <v-col
          cols="12"
          md="4"
          class="align-stretch"
          v-for="(teacher, k) in teachers"
          :key="k"
        >
          <v-card class="fill-height">
            <v-img
              aspect-ratio="1"
              v-if="teacher.avatar"
              :src="teacher.avatar.thumbnail"
            ></v-img>
            <v-card-title>{{ getFullName(teacher) }}</v-card-title>
            <v-card-subtitle>
              <div>{{ teacherTypes[teacher.place] }}</div>

              <div v-if="teacher.education">
                <span class="font-weight-bold">Специальность: </span>
                {{ teacher.education }}
              </div>
            </v-card-subtitle>
            <v-card-text v-if="teacher.get_subjects">
              <v-row justify="center">
                <v-chip
                  class="ma-1"
                  v-for="(subject, k) in teacher.get_subjects"
                  :key="k"
                >
                  {{ subject }}
                </v-chip>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </my-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import API from "@/common/api/api.functions";
import MainTitle from "@/components/MainTitle";
import MyContainer from "@/components/MyContainer";

export default {
  name: "Faces",
  components: { MyContainer, MainTitle },
  data: () => ({
    teachers: []
  }),
  computed: {
    ...mapGetters(["teacherTypes"])
  },
  methods: {
    async getTeachersData() {
      this.teachers = await API.getTeachers().then(response => response.data);
    },
    getFullName(teacher) {
      let fullName = [];
      if (teacher.last_name) fullName = [...fullName, teacher.last_name];
      if (teacher.first_name) fullName = [...fullName, teacher.first_name];
      if (teacher.middle_name) fullName = [...fullName, teacher.middle_name];
      return fullName.join(" ");
    }
  },
  mounted() {
    this.getTeachersData();
  }
};
</script>
